<template>
  <div class="card-item shadowless">
    <div class="consignment-main-data" :class="[showInvestors ? 'has-investors' : 'hasnt-investors']">
      <div class="item">
        <span class="has-text-weight-bold">{{ consignmentDictionary.createdAt }}</span>
        <span>{{ formatDate(consignmentData.createdAt, 'DD/MM/YYYY HH:mm:ss') }}</span>
      </div>
      <div v-if="showInvestors" class="item">
        <span class="has-text-weight-bold">{{ consignmentDictionary.investor }}</span>
        <span>{{ investor.name }}</span>
      </div>
      <div class="item">
        <span class="has-text-weight-bold">{{ consignmentDictionary.totalSecondaryCurrencyConsignedAmount }}</span>
        <span>$ {{ formatNumber(consignmentData.totalSecondaryCurrencyConsignedAmount) }}</span>
      </div>
      <div class="item">
        <span class="has-text-weight-bold">{{ consignmentDictionary.duesNumber }}</span>
        <span>{{ consignmentData.consignedPayments.length }}</span>
      </div>
      <div class="button-item">
        <a :id="`copy-button-${consignmentData._id}`" @click.prevent="copyToClipBoard()">
          <span class="icon">
            <i class="fas fa-table fa-lg" />
          </span>
        </a>
        <a
          href="javascript:void(0);"
          @click="setCurrentExtendedConsignment(consignmentIndex)">
          <span v-html="currentExtendedConsignment === consignmentIndex ? 'Ocultar ' : 'Ver info '" />
          <span class="fa fa-chevron-down transition-slow" :class="{rotate: currentExtendedConsignment === consignmentIndex}" />
        </a>
      </div>
    </div>
    <div v-if="showInvestors" class="consignment-details-data transition-slow" :class="{hide : currentExtendedConsignment !== consignmentIndex}">
      <div class="item">
        <span class="has-text-weight-bold">{{ consignmentDictionary.bankAccountType }}</span>
        <span>{{ investor.bankAccount.type }}</span>
      </div>
      <div class="item">
        <span class="has-text-weight-bold">{{ consignmentDictionary.bankAccountNumber }}</span>
        <span>{{ investor.bankAccount.number }}</span>
      </div>
      <div class="item">
        <span class="has-text-weight-bold">{{ consignmentDictionary.bankName }}</span>
        <span>{{ investor.bankAccount.bankName }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { dateToFormatedString } from '@/infrastructure/date';
import { formatNumber } from '@/infrastructure/format';

export default {
  name: 'InvestorConsignment',
  props: {
    investor: Object,
    consignmentData: Object,
    consignmentIndex: Number,
    currentExtendedConsignment: Number,
    showInvestors: Boolean,
    headers: Object
  },
  data() {
    return {
      consignmentDictionary: {
        createdAt: 'Fecha de Remesa',
        investor: 'Portafolio',
        totalSecondaryCurrencyConsignedAmount: 'Monto',
        duesNumber: '# Cuotas',
        bankAccountType: 'Tipo de Cuenta',
        bankAccountNumber: 'Número de Cuenta',
        bankName: 'Banco'
      }
    };
  },
  computed: {
    payments() {
      const consignment = this.consignmentData;
      const bankAccount = this.investor.bankAccount.number;
      const payments = [];
      consignment.consignedPayments.forEach(payment => {
        payments.push(this.formatData(consignment, payment, bankAccount));
      });
      return payments;
    }
  },
  methods: {
    formatDate: (date, format = 'DD/MM/YYYY', inputFormat = '') => dateToFormatedString(date, format, inputFormat),
    formatNumber: (number, decimals) => {
      return formatNumber({
        number,
        thousandSeparator: '.',
        groupOfDigitsLength: 3,
        decimalSeparator: ',',
        minDecimals: decimals,
        maxDecimals: decimals
      });
    },
    formatRut(rut) {
      const rutParts = rut.split('-');
      return `${this.formatNumber(Number(rutParts[0]))}-${rutParts[1]}`;
    },
    setCurrentExtendedConsignment(index) {
      const consignmentIndex = this.currentExtendedConsignment === index ? undefined : index;
      this.$emit('setCurrentExtendedConsignment', consignmentIndex);
    },
    formatData(consignment, payment, bankAccount) {
      return {
        companyOperationId: payment.companyOperationId,
        debtor: `${payment.client.name} ${payment.client.lastName}`,
        idNumberDebtor: this.formatRut(payment.clientIdNumber),
        paymentNumber: payment.paymentNumber,
        dueDate: this.formatDate(payment.dueDate, 'DD-MM-YYYY'),
        interest: this.formatNumber(payment.interest, 6),
        amortization: this.formatNumber(payment.amortization, 6),
        monthlyPayment: this.formatNumber(payment.monthlyPayment, 6),
        lateInterest: this.formatNumber(payment.lateInterest, 6),
        consignedAmount: this.formatNumber(payment.consignedAmount, 6),
        paymentCreatedAt: this.formatDate(payment.createdAt, 'DD-MM-YYYY'),
        secondaryCurrencyFactor: this.formatNumber(payment.secondaryCurrencyFactor, 2),
        provider: 'Creditú',
        bankAccount: Number(bankAccount),
        secondaryCurrencyConsignedAmount: this.formatNumber(payment.secondaryCurrencyConsignedAmount),
        consignmentCreatedAt: this.formatDate(consignment.createdAt, 'DD-MM-YYYY')

      };
    },
    copyToClipBoard() {
      const lines = [Object.values(this.headers).join('\t')];
      this.payments.forEach(payment => {
        lines.push(Object.values(payment).join('\t'));
      });
      const textToCopy = lines.join('\n');
      this.$copyText(textToCopy).then(result => {
        this.shakeButton();
        this.$emit('copySuccess', result);
      }).catch(error => {
        this.$emit('copyError', error);
      });
    },
    shakeButton() {
      const element = this.$el.querySelector(`#copy-button-${this.consignmentData._id}`);
      element.classList.remove('shaking');
      // eslint-disable-next-line no-unused-expressions
      element.offsetWidth;
      element.classList.add('shaking');
    }
  }
};
</script>

<style scoped>
  .consignment-main-data {
    display: grid;
    gap: 0.3 0.5rem;
    align-items: center;
    font-size: 0.8rem;
    padding: 10px;
  }
  .has-investors {
    grid-template-columns: repeat(5, minmax(100px, 1fr));
    grid-auto-columns: repeat(5, minmax(100px, 1fr));
  }
  .hasnt-investors {
    grid-template-columns: repeat(4, minmax(100px, 1fr));
    grid-auto-columns: repeat(4, minmax(100px, 1fr));
  }
  .consignment-main-data > .item,
  .consignment-details-data > .item {
    display: grid;
    grid-template-rows: repeat(2, auto);
    text-align: center;
  }
  .consignment-main-data > .button-item {
    display: grid;
    grid-template-columns: repeat(2, minmax(50px, 0.5fr));
    text-align: center;
  }
  .consignment-details-data {
    display: grid;
    grid-template-columns: repeat(3, minmax(100px, 1fr));
    grid-auto-columns: repeat(3, minmax(100px, 1fr));
    gap: 0.3 0.5rem;
    align-items: center;
    font-size: 0.8rem;
    background-color: #F9F9F9;
    border-radius: 15px;
    padding: 15px 20px;
  }
  .hide {
    display: none;
  }
  .rotate {
    transform: rotate(180deg);
  }
  .details-content a {
    text-decoration: none;
    font-size: 16px;
  }
  .shaking {
    animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
  }
  @media (max-width: 640px) {
    .consignment-main-data, .consignment-details-data {
      grid-template-columns: repeat(1, 1fr);
    }
    .consignment-main-data > .item,
    .consignment-main-data > .button-item,
    .consignment-details-data > .item {
      grid-template-columns: repeat(2, minmax(100px, 1fr));
      text-align: start;
    }
  }
  @keyframes shake {
    10%, 90% {
      transform: translate3d(-1px, 0, 0);
    }
    20%, 80% {
      transform: translate3d(2px, 0, 0);
    }
    30%, 50%, 70% {
      transform: translate3d(-4px, 0, 0);
    }
    40%, 60% {
      transform: translate3d(4px, 0, 0);
    }
  }
  </style>
